<mat-card>
  <div fxLayout="row" fxLayoutAlign="start center" class="mb-4">
    <button
      type="button"
      class="appear-horizontal"
      mat-button
      (click)="onCancel()"
    >
      <mat-icon>arrow_back</mat-icon>
    </button>
    <h1 *ngIf="router.url.includes('create')" class="my-2">
      {{ "MERCHANT.MARKETING.CREATE.TITLE" | translate }}
    </h1>
    <h1 *ngIf="router.url.includes('edit')" class="my-2">
      {{ "MERCHANT.MARKETING.EDIT.TITLE" | translate }}
    </h1>
  </div>

  <ng-container
    *ngIf="
      !(
        (router.url.includes('edit') && (areSitesLoaded$ | async) === false) ||
        (isMarketingDataLoaded$ | async) === false
      )
    "
  >
    <!-- TODO Visszatenni, ha kell a publikus mező szerkesztés -->

    <!--mat-card-title-group>
      <mat-checkbox
        class="easy-checkbox ms-auto"
        (change)="showVisibleFields = $event.checked"
        [checked]="showVisibleFields"
      >
        {{ "SHARED.VISIBLE_FIELDS.TOGGLE" | translate }}
      </mat-checkbox>
    </mat-card-title-group-->

    <form
      class="easy-form"
      [formGroup]="form"
      appScrollToInvalidControl
      [appEditableWithRole]="['MERCHANT_ADMIN']"
    >
      <!-- templates -->

      <ng-template let-name #boolField>
        <app-visible-fields-checkbox
          *ngIf="showVisibleFields"
          [fieldName]="name"
        ></app-visible-fields-checkbox>
        <mat-form-field>
          <app-easy-checkbox
            [formControlName]="name"
            [label]="TITLE + name | translate"
          ></app-easy-checkbox>
        </mat-form-field>
      </ng-template>

      <ng-template let-name #textField>
        <app-visible-fields-checkbox
          class="margin-top"
          *ngIf="showVisibleFields"
          [fieldName]="name"
        ></app-visible-fields-checkbox>
        <mat-form-field>
          <app-easy-input
            [label]="TITLE + name | translate"
            [formControlName]="name"
            [placeholder]="PLACEHOLDER + name | translate"
            [hideRequiredLabel]="false"
          ></app-easy-input>
        </mat-form-field>
      </ng-template>

      <ng-template let-name #localizedTextArea>
        <app-visible-fields-checkbox
          class="margin-top"
          *ngIf="showVisibleFields"
          [fieldName]="name"
        ></app-visible-fields-checkbox>
        <app-easy-localized-value-subform
          class="w-100"
          [formGroupAbstract]="form.get(name)!"
          [title]="TITLE + name"
          [textareaAutosizeMinRows]="3"
        ></app-easy-localized-value-subform>
      </ng-template>

      <!-- merchantSiteIds select -->

      <fieldset
        class="in-two-columns"
        [class.with-visible-fields]="showVisibleFields"
      >
        <app-visible-fields-checkbox
          class="margin-top"
          *ngIf="showVisibleFields"
          fieldName="merchantSiteIds"
        ></app-visible-fields-checkbox>

        <!-- TODO Ez kelleni fog valaha is? -->

        <!-- Profile image picker -->
        <!--
          <app-merchant-image-picker
            *ngIf="logoUploadEnabled"
            (fileSelectedEvent)="onProfileImageSelected($event)"
            (removePicture)="onRemovePicture()"
            [isLoading]="isProfileImageUploading$ | async"
            [placeholderUrl]="profileImageUrl$ | async"
            [title]="TITLE + 'PROFILE_IMAGE' | translate"
          ></app-merchant-image-picker>
        -->
        <!-- !Profile image picker -->

        <!-- TODO Chippel kellene majd a select és András designján elnevezés is szerepel -->

        <mat-form-field>
          <app-easy-select
            [label]="TITLE + 'MARKETING_DATA_SITES' | translate"
            formControlName="merchantSiteIds"
            [multiple]="true"
            [options]="(sites$ | async) ?? []"
            [labelAttribute]="'name'"
            [valueAttribute]="'id'"
            [hasEmptyOption]="false"
          >
          </app-easy-select>
        </mat-form-field>
      </fieldset>

      <div
        class="in-one-column"
        [class.with-visible-fields]="showVisibleFields"
      >
        <!-- marketingVideo text -->

        <ng-container
          *ngTemplateOutlet="
            textField;
            context: { $implicit: 'marketingVideo' }
          "
        ></ng-container>

        <!-- introduction localized -->

        <ng-container
          *ngTemplateOutlet="
            localizedTextArea;
            context: { $implicit: 'introduction' }
          "
        ></ng-container>

        <!-- tourismServices image-picker with localized descrpitions -->
        <app-visible-fields-checkbox
          class="margin-top"
          *ngIf="showVisibleFields"
          fieldName="tourismServices"
        ></app-visible-fields-checkbox>
        <fieldset>
          <legend class="ms-0">
            {{ TITLE + "tourismServices" | translate }}
          </legend>
          <ng-container formArrayName="tourismServices">
            <div
              *ngFor="let group of tourismServiceGroups; let i = index"
              class="in-one-column with-delete-btn"
            >
              <app-localized-tourism-service-subform
                [title]="TITLE + 'TOURISM_SERVICE'"
                [formGroupAbstract]="group"
              >
              </app-localized-tourism-service-subform>

              <button
                type="button"
                mat-icon-button
                (click)="onDeleteTourismService(i)"
              >
                <mat-icon>delete_forever</mat-icon>
              </button>
            </div>
          </ng-container>
          <button
            class="w-100"
            type="button"
            mat-raised-button
            color="primary"
            (click)="onAddTourismService()"
          >
            {{ "MERCHANT.BTN.ADD_SERVICE" | translate }}
          </button>
        </fieldset>

        <!-- a localized list of promotions -->

        <app-visible-fields-checkbox
          class="margin-top"
          *ngIf="showVisibleFields"
          fieldName="promotions"
        ></app-visible-fields-checkbox>
        <fieldset>
          <legend class="ms-0">
            {{ TITLE + "promotions" | translate }}
          </legend>
          <ng-container formArrayName="promotions">
            <div
              *ngFor="let group of promotionGroups; let i = index"
              class="in-one-column with-delete-btn"
            >
              <app-easy-localized-value-subform
                class="w-100 easy-localized-value-subform"
                [formGroupAbstract]="group"
                [title]="TITLE + 'PROMOTION'"
                [textareaAutosizeMinRows]="3"
              ></app-easy-localized-value-subform>

              <button
                type="button"
                mat-icon-button
                (click)="onDeletePromotion(i)"
              >
                <mat-icon>delete_forever</mat-icon>
              </button>
            </div>
          </ng-container>
          <button
            class="w-100"
            type="button"
            mat-raised-button
            color="primary"
            (click)="onAddPromotion()"
          >
            {{ "MERCHANT.BTN.ADD_PROMOTION" | translate }}
          </button>
        </fieldset>
      </div>

      <div class="button-row">
        <button
          type="button"
          *ngIf="router.url.includes('edit')"
          mat-raised-button
          (click)="onCancel()"
        >
          {{ "MERCHANT.BTN.CANCEL" | translate | uppercase }}
        </button>
        <button mat-raised-button color="primary" (click)="onSubmit()">
          <span *ngIf="router.url.includes('edit')">
            {{ "MERCHANT.BTN.UPDATE" | translate | uppercase }}
          </span>
          <span *ngIf="!router.url.includes('edit')">
            {{ "MERCHANT.BTN.CREATE" | translate | uppercase }}
          </span>
        </button>
      </div>
    </form>
  </ng-container>
</mat-card>
